var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"photo"},[_c('img',{attrs:{"src":_vm.url,"width":"70%"}})])}
var staticRenderFns = []

export { render, staticRenderFns }